/**
 * Clamps a raw input value to the given bounds on blur. Empty / non-numeric
 * inputs collapse to `min` (or 0 when no min is given) so the field never
 * retains an invalid value after the user moves focus away.
 */
export const clampNumeric = (
  value: unknown,
  { min, max }: { min?: number; max?: number }
): number => {
  const parsed = Number(value ?? '')
  const safe = Number.isFinite(parsed) ? parsed : (min ?? 0)
  const lowerBounded = min !== undefined ? Math.max(safe, min) : safe
  return max !== undefined ? Math.min(lowerBounded, max) : lowerBounded
}
